import type { DemoKey } from './keys';

export const ja: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': '幾何学 · 3D',
  'panel.figure': '図形',
  'panel.dims': '寸法',
  'panel.style': '外観',
  'panel.lines': '特殊な線',
  'style.body': '本体',
  'style.line': '線',
  'style.cut': '断面',
  'style.labels': '頂点ラベル',
  'group.face': '面の対角線 / 母線',
  'group.space': '対角線 / 軸 / 中線',
  'split.label': '断面',
  'btn.animate': 'アニメーション',
  'btn.reset': 'リセット',
  'hint.line1': 'ドラッグで回転 · スクロールでズーム',
  'hint.line2': '線をクリックして選択',
  'fig.cuboid': '直方体',
  'fig.cube': '立方体',
  'fig.triPrism': '三角柱',
  'fig.hexPrism': '六角柱',
  'fig.tetrahedron': '正四面体',
  'fig.squarePyramid': '四角錐',
  'fig.cylinder': '円柱',
  'fig.cone': '円錐',
  'fig.sphere': '球',
  'fig.frustumPyramid': '角錐台',
  'fig.frustumCone': '円錐台',
  'dim.length': '長さ',
  'dim.width': '幅',
  'dim.height': '高さ',
  'dim.side': '辺',
  'dim.radius': '半径',
  'dim.r1': '下半径',
  'dim.r2': '上半径',
  'dim.sideBase': '底辺',
  'dim.sideTop': '上底辺',
  'info.face': '面',
  'info.center': '中心通過',
  'info.diagonal': '対角線',
  'info.axial': '軸対角線',
  'info.diameter': '直径',
  'info.generator': '母線',
  'info.axis': '軸',
  'info.height': '高さ',
  'info.median': '中線',
  'info.apothem': '底心距',
  'info.diameterBase': '底面の直径',
  'info.diameterTop': '上面の直径',
};
